import { render, staticRenderFns } from "./SupplierViewContactsAddContactModal.vue?vue&type=template&id=a756eeb8"
import script from "./SupplierViewContactsAddContactModal.vue?vue&type=script&lang=js"
export * from "./SupplierViewContactsAddContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports